/*=========================================================================================
  File Name: moduleChatActions.js
  Description: Chat Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from '@/axios.js'
import { database, authReady } from '@/firebase.js'
import {
  ref as dbRef,
  update as dbUpdate,
  increment,
  push as dbPush,
  onChildAdded,
  onValue,
  query,
  orderByChild
} from 'firebase/database'
export default {
  setChatSearchQuery({ commit }, query) {
    commit('SET_CHAT_SEARCH_QUERY', query)
  },
  updateAboutChat({ commit, rootState }, value) {
    commit('UPDATE_ABOUT_CHAT', {
      rootState,
      value
    })
  },
  updateStatusChat({ commit, rootState }, value) {
    commit('UPDATE_STATUS_CHAT', {
      rootState,
      value
    })
  },

  // API CALLS
  async sendChatMessage({ getters, commit, dispatch }, payload) {
    return new Promise(async (resolve, reject) => {
      var chat_id = ''
      const user = localStorage.getItem('user')
      const userData = JSON.parse(user)
      const rawUserId = userData?.uid || userData?.uuid || userData?.id
      if (!rawUserId) return reject(new Error('Missing user id'))
      var user_id = String(rawUserId).replace(/-/g, '')
      // let chat_user = null;
  var chatUserImg = localStorage.getItem('chatUserImg')
  var chatUserID = localStorage.getItem('chatUserID')
  var chatUserName = localStorage.getItem('chatUserName')
      const safe = (v) => (v && v !== 'undefined' ? v : '')
      // Fallbacks if any counterpart info is missing
      if (!chatUserID || chatUserID === 'undefined' || !chatUserName || !chatUserImg || chatUserImg === 'undefined') {
        try {
          const role = userData?.userRole
          const raw = role === 'provider' ? localStorage.getItem('callingTo') : localStorage.getItem('caller')
          const obj = raw ? JSON.parse(raw) : null
          if (obj) {
            const rawId = obj?.uuid || obj?.uid || obj?.id
            chatUserID = chatUserID || (rawId ? String(rawId).replace(/-/g, '') : '')
            chatUserName = chatUserName || (obj?.name || obj?.fullName || '')
            chatUserImg = safe(chatUserImg) || safe(obj?.avatar || obj?.image || obj?.photoURL || obj?.profileImage)
          }
        } catch (_) {}
      }
      chatUserImg = safe(chatUserImg)
      // return false;
      // if (userData.userRole == "provider")
      //   chat_user = localStorage.getItem("callingTo");
      // else chat_user = localStorage.getItem("caller");
      // const pau = JSON.parse(chat_user);
      // Normalize chatUserID and ensure it's a string without dashes
      try { chatUserID = chatUserID ? String(chatUserID).replace(/-/g, '') : '' } catch (_) { chatUserID = '' }
      var chat_user_id = chatUserID

      // If we don't have a valid counterpart id at this point, abort to avoid writing invalid/null chats
      if (!chat_user_id) {
        try {
          //  console.log('[chat] sendChatMessage: missing chat_user_id, aborting write') 
          } catch (_) {}
        return reject(new Error('Missing chat counterpart id'))
      }

      // Ensure we never write undefined to RTDB (update disallows undefined)
      const userName =
        userData?.name ||
        userData?.fullName ||
        userData?.username ||
        userData?.displayName ||
        [userData?.firstName, userData?.lastName].filter(Boolean).join(' ')

      if (user_id < chat_user_id) {
        chat_id = user_id + chat_user_id
        dbUpdate(dbRef(database, 'chats/' + chat_id), {
          user1_id: user_id,
          user1_name: userName || ''
        })
      } else {
        chat_id = chat_user_id + user_id
        dbUpdate(dbRef(database, 'chats/' + chat_id), {
          user2_id: user_id,
          user2_name: userName || ''
        })
      }
      // Sanitize message payload to avoid undefined writes
      const safeStr = (v) => (v && v !== 'undefined' ? String(v) : '')
      // Resolve Promise text if accidentally passed
      let textValue = payload?.text
      try {
        if (textValue && typeof textValue.then === 'function') {
          textValue = await textValue
        }
      } catch (_) {
        textValue = ''
      }
      textValue = safeStr(textValue)
      const cleanPayload = {
        ...payload,
        user_name: safeStr(payload?.user_name),
        text: textValue,
        type: payload?.type ?? 1,
        timestamp: payload?.timestamp ?? Date.now()
      }
  dbPush(dbRef(database, 'messages/' + chat_id), cleanPayload)
      var myInfo = {
        user_id: chat_user_id,
        name: chatUserName || '',
        image: chatUserImg || '',
        message: textValue,
        timestamp: cleanPayload.timestamp
      }
      dbUpdate(
        dbRef(database, 'chatLists/' + user_id + '/' + chat_user_id),
        myInfo
      )

      const senderImage = safe(userData?.avatar || userData?.image || userData?.photoURL || userData?.profileImage)
      var doctorInfo = {
        user_id: user_id,
        name: userName || '',
        image: senderImage,
        message: textValue,
        // TB-191: same counter the app keeps, so unread totals agree across web and app
        unreadCount: increment(1),
        timestamp: cleanPayload.timestamp
      }
      dbUpdate(
        dbRef(database, 'chatLists/' + chat_user_id + '/' + user_id),
        doctorInfo
      )

      // Do NOT remove chatUser* localStorage keys here. They reflect the currently-selected chat partner
      // and removing them causes race conditions when multiple messages are sent quickly, which can
      // result in empty/null chat entries being created in the DB.
      resolve(true)
    })
  },

  // Get contacts from server. Also change in store
  fetchContacts({ commit, state }) {
    return Promise.resolve(authReady).catch(() => null).then(() => new Promise((resolve) => {
      try {
        const user = localStorage.getItem('user')
        if (!user) return resolve([])
        const userData = JSON.parse(user)
        const rawUserId = userData?.uid || userData?.uuid || userData?.id
        if (!rawUserId) return resolve([])
        const user_id = String(rawUserId).replace(/-/g, '')

        // Unsubscribe previous contacts listener
        try {
          state?._unsub?.contacts && state._unsub?.contacts()
          commit('SET_CONTACTS_UNSUB', null)
        } catch {}

        const listRef = dbRef(database, 'chatLists/' + user_id)
        let resolved = false
        const unsub = onValue(listRef, (snapshot) => {
          const val = snapshot.val() || {}
          const rawArray = Object.values(val)
          // LocalStorage fallbacks for counterpart details
          let callerObj = null, callingToObj = null, callerId = null, callingToId = null
          try {
            const cRaw = localStorage.getItem('caller')
            if (cRaw) { callerObj = JSON.parse(cRaw); callerId = String((callerObj.uuid || callerObj.uid || callerObj.id || '')).replace(/-/g, '') }
          } catch {}
          try {
            const ctRaw = localStorage.getItem('callingTo')
            if (ctRaw) { callingToObj = JSON.parse(ctRaw); callingToId = String((callingToObj.uuid || callingToObj.uid || callingToObj.id || '')).replace(/-/g, '') }
          } catch {}
          // Normalize avatar field and guard against 'undefined' string values
          const inboxArray = rawArray.map((c) => {
            let img = c?.image && c.image !== 'undefined' ? c.image : (c?.avatar || c?.photoURL || c?.profileImage || '')
            if (!img || img === 'undefined') {
              if (callerId && c?.user_id === callerId) img = callerObj?.avatar || callerObj?.image || img
              if ((!img || img === 'undefined') && callingToId && c?.user_id === callingToId) img = callingToObj?.avatar || callingToObj?.image || img
            }
            const name = c?.name || c?.fullName || c?.username || ''
            return { ...c, image: img, name, unread: Number(c?.unreadCount) || 0 }
          }).sort(
            (a, b) => Number(b.timestamp || 0) - Number(a.timestamp || 0)
          )

          // A consultation can be messaged before the first message exists.
          // In that case Firebase has no chatLists entry yet, so expose the
          // selected patient as a contact from the consultation context.
          if (userData?.userRole === 'provider' && callingToId && !inboxArray.some(c => c.user_id === callingToId)) {
            inboxArray.unshift({
              user_id: callingToId,
              name: callingToObj?.name || callingToObj?.fullName || '',
              image: callingToObj?.avatar || callingToObj?.image || '',
              message: '',
              timestamp: 0
            })
          }
          commit('UPDATE_CONTACTS', inboxArray)
          if (!resolved) {
            resolved = true
            resolve(inboxArray)
          }
        }, () => {
          if (!resolved) {
            resolved = true
            resolve([])
          }
        })
        commit('SET_CONTACTS_UNSUB', unsub)
      } catch (e) {
        // console.log('fetchContacts error:', e)
        resolve([])
      }
    }))
  },

  // Get chat-contacts from server. Also change in store
  fetchChatContacts({ commit, state }) {
    return new Promise((resolve) => {
      try {
        const user = localStorage.getItem('user')
        if (!user) return resolve([])
        const userData = JSON.parse(user)
        const rawUserId = userData?.uid || userData?.uuid || userData?.id
        if (!rawUserId) return resolve([])
        const user_id = String(rawUserId).replace(/-/g, '')

        // We can reuse the same data as contacts; subscribe separately to avoid breaking existing calls
        const listRef = dbRef(database, 'chatLists/' + user_id)
        let resolved = false
        const unsub = onValue(listRef, (snapshot) => {
          const val = snapshot.val() || {}
          const rawArray = Object.values(val)
          let callerObj = null, callingToObj = null, callerId = null, callingToId = null
          try {
            const cRaw = localStorage.getItem('caller')
            if (cRaw) { callerObj = JSON.parse(cRaw); callerId = String((callerObj.uuid || callerObj.uid || callerObj.id || '')).replace(/-/g, '') }
          } catch {}
          try {
            const ctRaw = localStorage.getItem('callingTo')
            if (ctRaw) { callingToObj = JSON.parse(ctRaw); callingToId = String((callingToObj.uuid || callingToObj.uid || callingToObj.id || '')).replace(/-/g, '') }
          } catch {}
          const inboxArray = rawArray.map((c) => {
            let img = c?.image && c.image !== 'undefined' ? c.image : (c?.avatar || c?.photoURL || c?.profileImage || '')
            if (!img || img === 'undefined') {
              if (callerId && c?.user_id === callerId) img = callerObj?.avatar || callerObj?.image || img
              if ((!img || img === 'undefined') && callingToId && c?.user_id === callingToId) img = callingToObj?.avatar || callingToObj?.image || img
            }
            const name = c?.name || c?.fullName || c?.username || ''
            return { ...c, image: img, name, unread: Number(c?.unreadCount) || 0 }
          }).sort(
            (a, b) => Number(b.timestamp || 0) - Number(a.timestamp || 0)
          )
          commit('UPDATE_CHAT_CONTACTS', inboxArray)
          if (!resolved) {
            resolved = true
            resolve(inboxArray)
          }
        })
        // Do not store a separate unsub for chatContacts to avoid clobbering contacts listener
        // Callers can ignore unsubscribe here
      } catch (e) {
        // console.log('fetchChatContacts error:', e)
        resolve([])
      }
    })
  },

  // Get chats from server. Also change in store
  fetchChats({ commit, state }, payload, exrtaCallBack = () => {}) {
    return Promise.resolve(authReady).catch(() => null).then(() => new Promise((resolve) => {
      let chat_id = ''
      const user = localStorage.getItem('user')
      const userData = JSON.parse(user)
      const rawUserId = userData?.uid || userData?.uuid || userData?.id
      if (!rawUserId) return resolve([])
      let chat_user = null
      if (userData.userRole == 'provider')
        chat_user = localStorage.getItem('callingTo')
      else chat_user = localStorage.getItem('caller')

      const chatUserData = JSON.parse(chat_user)
      const user_id = String(rawUserId).replace(/-/g, '')
      const chat_user_id = payload
      if (user_id < chat_user_id) {
        chat_id = user_id + chat_user_id
        dbUpdate(dbRef(database, 'chats/' + chat_id), {
          user1_id: user_id,
          user1_name: (userData?.name || userData?.fullName || userData?.username || userData?.displayName || [userData?.firstName, userData?.lastName].filter(Boolean).join(' ')) || ''
        })
      } else {
        chat_id = chat_user_id + user_id
        dbUpdate(dbRef(database, 'chats/' + chat_id), {
          user2_id: user_id,
          user2_name: (userData?.name || userData?.fullName || userData?.username || userData?.displayName || [userData?.firstName, userData?.lastName].filter(Boolean).join(' ')) || ''
        })
      }
      // If a listener is already attached for this chat id, skip re-attaching to avoid duplicates
      try {
        if (state && state._currentChatId && state._currentChatId === chat_id) {
          // Already listening to this chat_id — skip re-attaching
          try { 
            // console.debug('[chat] fetchChats: already subscribed to', chat_id) 

          } catch {}
          if (state.chats && state.chats.length) {
            exrtaCallBack(state.chats)
            resolve(state.chats)
            return
          }
        }
        // Unsubscribe previous chat listener if different chat
        try {
          if (state?._unsub?.chat) {
            try { 
              // console.debug('[chat] fetchChats: unsubscribing previous listener for', state._currentChatId)
             } catch {}
            state._unsub.chat()
          }
        } catch (e) {
          try { 
            // console.warn('[chat] fetchChats: error during unsubscribe', e) 

          } catch {}
        }
        commit('SET_CHAT_UNSUB', null)
        commit('SET_CURRENT_CHAT_ID', null)
      } catch (e) {
        try { 
          // console.warn('[chat] fetchChats: unexpected error', e)
         } catch {}
      }

      const messagesRef = dbRef(database, 'messages/' + chat_id)
      let resolved = false
  try { 
    // console.debug('[chat] fetchChats: attaching listener for', chat_id) 
  } catch {}
  const unsub = onValue(messagesRef, (snapshot) => {
        const val = snapshot.val() || {}
        const inboxArray = Object.values(val).map((m) => {
          const raw = m?.text
          let text = ''
          try {
            text = (raw == null || raw === 'undefined') ? '' : String(raw)
          } catch (_) { text = '' }
          const trimmed = text.trim()
          const safeText = (trimmed === '[object Promise]') ? '' : text
          return { ...m, text: safeText }
        }).sort(
          (a, b) => Number(a.timestamp || 0) - Number(b.timestamp || 0)
        )
        exrtaCallBack(inboxArray)
        commit('UPDATE_CHATS', inboxArray)
        if (!resolved) {
          resolved = true
          resolve(inboxArray)
        }
      })
      commit('SET_CHAT_UNSUB', unsub)
      // Remember the chat id for which listener is active so we don't re-register it
      commit('SET_CURRENT_CHAT_ID', chat_id)
      try {
        //  console.debug('[chat] fetchChats: listener attached for', chat_id) 
        } catch {}
    }))
  },

  // Cleanup any active realtime listeners (use on logout/unmount)
  cleanupListeners({ state, commit }) {
    try {
      state?._unsub?.contacts && state._unsub?.contacts()
    } catch {}
    try {
      state?._unsub?.chat && state._unsub.chat()
    } catch {}
    commit('SET_CONTACTS_UNSUB', null)
    commit('SET_CHAT_UNSUB', null)
  },

  // Reset local chat state arrays after cleanup
  resetChatState({ commit }) {
    commit('RESET_CHAT_STATE')
  },

  markSeenAllMessages({ getters, commit }, id) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/apps/chat/mark-all-seen', { id })
        .then((response) => {
          commit('MARK_SEEN_ALL_MESSAGES', {
            id,
            chatData: getters.chatDataOfUser(id)
          })
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  toggleIsPinned({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/apps/chat/set-pinned/', {
          contactId: payload.id,
          value: payload.value
        })
        .then((response) => {
          commit('TOGGLE_IS_PINNED', payload)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }
}
